import React, { useState, useEffect, useRef } from 'react';
import { get } from '../../services/apiController';
import { DEBOUNCE_DELAY } from '../../util/constant';
import { Col, FloatingLabel, Form, Row, Table } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../components/Breadcrumb';
import PaginationInPage from '../Pagination';
import moment from 'moment';
import { GrDocumentExcel } from 'react-icons/gr';
import { DownloadIcon, EditIcon, ViewIcon } from '../icons';
import OrderEditModal from './components/OrderEditModal';
import { Link } from 'react-router-dom';
import useDebounce from '../useDebounce';
import { useDispatch, useSelector } from 'react-redux';
import { FetchSubCategories } from '../../store/reducers/cake_sub_category_reducer';
import Select from '../../components/atoms/Select';
import { getStoredData, get_auth_key } from '../../util';

const CakeOrder = () => {
  const TABLE_DEFAULT_LIMIT = 100;
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [orderList, setOrderList] = useState([]);
  const clickToDownload = useRef(null);
  const [orderEditModal, setEditModal] = useState(false);
  const [order, setOrder] = useState({});
  const [locationList, setLocationList] = useState([]);
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'cake-admin'].includes(storedData.role);

  const [filters, setFilters] = useState({
    locationId: '',
    subCategoryId: '',
    status: '',
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
  });

  const handleFilterChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const subCategoryList = useSelector((state) => state?.cake_sub_categories?.subCategories);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FetchSubCategories('&categoryId=1'));
  }, [dispatch]);

  const handleEdit = (e, orderId) => {
    e.preventDefault();
    const order = orderList.find((order) => {
      return order.id === +orderId;
    });
    if (order) {
      setOrder(order);
      setEditModal(true);
    }
  };

  function fetchOrders(conditions) {
    try {
      let url = `/cake/orders/?dateFrom=${filters.dateFrom}&dateTo=${filters.dateTo}&subCategoryId=${filters.subCategoryId}&locationId=${filters.locationId}&status=${filters.status}`;
      if (conditions === 'excel') {
        url += `&conditionType=download`;
      } else {
        url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
      }
      get(url).then((response) => {
        if (conditions === 'excel') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setOrderList(response.data.rows);
          setTotalRecords(response.data.count ?? 0);
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        fetchOrders();
      }
    },
    [filters],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    fetchOrders();
  }, [currentPage]);

  useEffect(() => {
    get(`/branches`)
      .then((response) => {
        setLocationList(response?.data?.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  }, []);

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Cake Managment' },
          { link: '#', title: 'Orders' },
        ]}
      />
      <div>
        <Link to={'/cake/home'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
        </Link>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Orders | {totalRecords ?? 0}
          </h4>
          <Row>
            {admins && (
              <Col xs={2}>
                <FloatingLabel controlId="floatingSelect" label="Location" className="mb-3">
                  <Form.Select className="input" value={filters.locationId} name="locationId" onChange={handleFilterChange}>
                    <option value="">Select All</option>
                    {locationList?.map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {`${item?.name} (${item?.number})`}
                        </option>
                      );
                    })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
            )}
            <Col xs={admins ? 2 : 3}>
              <FloatingLabel controlId="floatingSelect" label="Cake Type" className="mb-3">
                <Select
                  value={filters.subCategoryId}
                  name="subCategoryId"
                  label="All"
                  onChange={handleFilterChange}
                  data={subCategoryList}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      minHeight: '55px',
                    }),
                  }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={2}>
              <FloatingLabel controlId="floatingSelect" label="Status">
                <Form.Select name="status" value={filters.status} onChange={handleFilterChange} className="form-select">
                  <option value="">All</option>
                  <option value="accepted">Accepted</option>
                  <option value="cancelled">Cancelled</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col xs={admins ? 2 : 3}>
              <FloatingLabel controlId="floatingInput" label="Date From">
                <Form.Control name="dateFrom" onChange={handleFilterChange} value={filters.dateFrom} type="date" />
              </FloatingLabel>
            </Col>
            <Col xs={admins ? 2 : 3}>
              <FloatingLabel controlId="floatingInput" label="Date To">
                <Form.Control name="dateTo" onChange={handleFilterChange} value={filters.dateTo} type="date" />
              </FloatingLabel>
            </Col>
            <Col style={{ alignContent: 'center' }} xs={admins ? 2 : 1}>
              <GrDocumentExcel
                title="Download excel"
                style={{ cursor: 'pointer', width: '30px', height: '30px' }}
                className="react-icons green"
                onClick={() => fetchOrders('excel')}
              />
              <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </Col>
          </Row>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Shop Location</th>
                    <th>Flavour</th>
                    <th>Shape</th>
                    <th>Weight (Kg)</th>
                    <th>Name on the cake</th>
                    <th>Special Instructions</th>
                    <th>Order Amt (₹)</th>
                    <th>Cake Price Per Unit (₹)</th>
                    <th>Flavour Price Per Unit (₹)</th>
                    <th>Extra Charge (₹)</th>
                    <th>Product Code</th>
                    <th>Delivery Date</th>
                    <th>Cake Name</th>
                    <th>Order Number</th>
                    <th>Status</th>
                    <th>Download Photo</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orderList?.map((item, index) => {
                    const BasePath = item.syncedOnBucket ? process.env.REACT_APP_DIGITAL_OCEAN_URL : process.env.REACT_APP_BASE_URL;
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{`${item?.location?.name} (${item?.location?.number})`}</td>
                        <td>{item?.flavour?.name}</td>
                        <td>{item?.shape?.name}</td>
                        <td>{item?.weight}</td>
                        <td>{item?.nameOnCake}</td>
                        <td>{item?.instruction}</td>
                        <td>{item?.orderAmount}</td>
                        <td>{item?.perUnitCakePrice}</td>
                        <td>{item?.perUnitFlavourPrice}</td>
                        <td>{item?.extraCharge}</td>
                        <td>{item?.product?.productCode}</td>
                        <td>{moment(item?.deliveryDate).format('DD/MM/YYYY')}</td>
                        <td>{item?.product?.name}</td>
                        <td>{item?.orderNumber}</td>
                        <td style={{ textTransform: 'capitalize' }}>{item?.status}</td>
                        <td>
                          {Array.isArray(item?.images) ? (
                            item?.images?.map((image) => (
                              <a href={`${BasePath}/${image}`} target="_blank" rel="noreferrer" className="px-1">
                                <DownloadIcon style={{ color: 'purple' }} />
                              </a>
                            ))
                          ) : item?.images ? (
                            <a href={`${BasePath}/${item?.images}`} target="_blank" rel="noreferrer">
                              <DownloadIcon style={{ color: 'purple' }} />
                            </a>
                          ) : (
                            ''
                          )}
                        </td>
                        <td>
                          <a title="Update Order Details" href="/" onClick={(e) => handleEdit(e, item?.id)}>
                            <EditIcon style={{ color: 'teal', marginRight: '5px' }} />
                          </a>
                          <a title="View Order Details" href={`#/cake/order-print/${item.id}`} target="_blank" rel="noreferrer">
                            <ViewIcon style={{ color: 'purple' }} />
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {orderEditModal && (
        <OrderEditModal
          show={orderEditModal}
          closeModal={() => setEditModal(false)}
          orderId={order?.id}
          productId={order?.product?.id}
          fetchOrders={() => fetchOrders()}
        />
      )}
    </>
  );
};

export default CakeOrder;
